module.exports = __webpack_public_path__ + "img/vertical_6_3_9006.7c22ba4a.png";